module.exports = __webpack_public_path__ + "static/media/chart.263b79df.svg";